export default {
	"PageLoading.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization": "微信授权后可进入访问，请求授权中···",
	"PageLoading.OhWellSomethingWentWrong": "哦哦，出错了！",
	"PageLoading.ShoutingIsComing": "叫叫正在赶来..."
}